/** @jsxImportSource @emotion/react */

import SearchBoxContainer from '@components/common/SearchBox/containers/SearchBoxContainer';
import { BLACK, WHITE } from '@constants/colors';
import { css } from '@emotion/react';
import { RegionType } from '@typedef/api/common.types';

type Props = {
  region: RegionType;
  searchInput: string;
  handleChangeInput: (value: string) => void;
  handleSubmit: () => void;
};

const SearchSection = ({
  region,
  searchInput,
  handleChangeInput,
  handleSubmit,
}: Props) => {
  return (
    <div
      css={css`
        min-height: 143px;
        background-color: ${WHITE};
        padding: 25px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
      `}>
      <div
        className='h1'
        css={css`
          color: ${BLACK};
        `}>
        {region.name}
      </div>
      <div
        css={css`
          width: 100%;
        `}>
        <SearchBoxContainer
          onSubmit={handleSubmit}
          className='add-location-search'
          value={searchInput}
          onChange={({ value }) => {
            handleChangeInput(value);
          }}
          onReset={() => {
            handleChangeInput('');
          }}
        />
      </div>
    </div>
  );
};

export default SearchSection;
